import React from 'react';
import { Button } from '../ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '../ui/select';

interface Props {
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  resultsPerPage: number;
  setResultsPerPage: React.Dispatch<React.SetStateAction<number>>;
}

function DataTablePagination({
  totalItems,
  itemsPerPage,
  currentPage,
  setCurrentPage,
  resultsPerPage,
  setResultsPerPage
}: Props) {
  const getTotalPages = (): number => {
    return Math.ceil(totalItems / itemsPerPage);
  };

  const handleResultsPerPageChange = (value: string) => {
    setResultsPerPage(Number(value));
  };

  return (
    <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4'>
      <div className='flex items-center justify-center sm:justify-start space-x-2'>
        <p className='text-sm font-medium'>Rows per page</p>
        <Select
          value={resultsPerPage.toString()}
          onValueChange={handleResultsPerPageChange}
        >
          <SelectTrigger className='h-8 !w-20'>
            <SelectValue placeholder={resultsPerPage} />
          </SelectTrigger>
          <SelectContent side='top' className='!w-14 !min-w-20'>
            <SelectItem value='10'>10</SelectItem>
            <SelectItem value='25'>25</SelectItem>
            <SelectItem value='50'>50</SelectItem>
            <SelectItem value='100'>100</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className='flex flex-col sm:flex-row items-center gap-4 sm:gap-6'>
        <div className='flex items-center space-x-2'>
          <p className='text-sm font-medium'>
            Page {currentPage} of {getTotalPages()}
          </p>
        </div>
        <div className='flex items-center space-x-2'>
          <Button
            variant='outline'
            size='sm'
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </Button>
          <Button
            variant='outline'
            size='sm'
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, getTotalPages()))
            }
            disabled={currentPage === getTotalPages()}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DataTablePagination;
